// JavaScript to toggle between src and gifsrc on hover for each pair of elements
const hoverGifs = document.querySelectorAll(".hover-gif");

hoverGifs.forEach((hoverGif) => {
    const parentDiv = hoverGif.closest(".nosto-column");

    const originalSrc = hoverGif.getAttribute("src");
    const gifSrc = hoverGif.getAttribute("gifsrc");

    parentDiv.addEventListener("mouseenter", () => {
        hoverGif.setAttribute("src", gifSrc);
    });

    parentDiv.addEventListener("mouseleave", () => {
        hoverGif.setAttribute("src", originalSrc);
    });
});
